// AUTO-GENERATED GraphQL Builder for ReuploadInfo
import * as Builders from '../';
export class ReuploadInfoBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  valid(){ return this.add('valid'); }
  vendorName(){ return this.add('vendorName'); }

  rejected(b?:(q:Builders.ReuploadCheckBuilder)=>void){
    if(this.depth>=5||this.v.has('rejected'))return this;
    this.v.add('rejected');
    const n=new Builders.ReuploadCheckBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`rejected { ${inner} }`);
    return this;
  }
}
